import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.seal.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import '@wangeditor/editor/dist/css/style.css'; // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import selectPerson from '@/components/select-person';
import config from '@/pathConfig';
import { batchUploadFile } from '@/api/commonApi.js';
import { queryNoticeFillDetails, saveFeedBack, queryFeedBack, examineFeedback, queryFeedAuditRecord, queryFeedAuditRecordRec, judgeDirector, judgeDirectorJWB } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    return {
      config: config,
      colorItem: {
        '0': 'green',
        '1': 'red',
        '2': 'blue',
        '3': 'gray'
      },
      flowList: [],
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      options: [],
      // 级联选择数据
      userInfo: this.$hdk.userInfo.get(),
      businessId: 2,
      // 业务id 1公文流转 2通知通告
      editor: null,
      toolbarConfig: {
        excludeKeys: ['fullScreen', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入公告内容'
      },
      mode: 'default',
      // or 'default'
      formObject: {},
      auditFormObj: {
        auditStatus: 0,
        // 0 通过 1 不通过 3已驳回
        allow: '',
        // 是否创建节点 0是 1否
        fbid: '',
        // 反馈id
        auditOpinion: '',
        // 审核意见
        sign: '',
        // 签字信息
        node: undefined,
        // 驳回的节点id(反馈审核记录id)
        appendName: '' // 驳回的时候传
      },
      rules: {
        auditOpinion: [{
          required: false,
          message: '请输入审核意见'
        }, {
          max: 200,
          message: '字数超出限制200'
        }],
        node: [{
          required: false,
          message: '请选择驳回节点'
        }]
      },
      formObjFeed: {
        fillId: this.$route.query.fillId,
        userName: '',
        organPostId: [],
        typeId: '',
        organId: '',
        postId: '',
        content: '',
        files: []
      },
      nodeList: [],
      isDirector: false,
      isDirectorJWB: false
    };
  },
  mounted: function mounted() {
    this.getNoticeFillDetails();
  },
  methods: {
    /**
     * 根据id查询详情
     */
    getNoticeFillDetails: function getNoticeFillDetails() {
      var _this = this;
      var $route = this.$route,
        userInfo = this.userInfo,
        formObject = this.formObject;
      this.formObjFeed.userName = userInfo.userName;

      // 级联数据处理 
      this.options = _.map(userInfo.organPostTree, function (item) {
        item.postList = _.map(item.postList, function (subItem) {
          return {
            label: subItem.postName,
            value: subItem.postId,
            children: null
          };
        });
        return {
          label: item.organName,
          value: item.organId,
          typeId: item.typeId,
          children: item.postList
        };
      });
      // 根据公告id查询反馈信息
      queryFeedBack($route.query.id).then(function (res) {
        _this.formObjFeed = res.data.data;
        _this.formObjFeed.organAndPost = "".concat(_this.formObjFeed.organName, " / ").concat(_this.formObjFeed.postName);
      });

      // 通知公告详情
      var id = $route.query.fillId;
      queryNoticeFillDetails(id).then(function (res) {
        _this.formObject = res.data.data;
        // 所属组织及岗位赋值
        _this.formObject.organAndPost = "".concat(_this.formObject.organName, " / ").concat(_this.formObject.postName);

        // 判断财务室主任提交时是否需要财务总监审核
        judgeDirector({
          organId: _this.formObject.organId,
          postId: _this.formObject.postId
        }).then(function (res) {
          _this.isDirector = res.data.data;
        });
        // 判断是否是纪委办主任
        judgeDirectorJWB({
          organId: _this.formObject.organId,
          postId: _this.formObject.postId
        }).then(function (res) {
          _this.isDirectorJWB = res.data.data;
        });

        // 当前组织层级指定人员
        if (_this.formObject.range === 3) {
          _this.optionVal = _.map(_this.formObject.scope, function (item) {
            return item.userId;
          });
        } else {
          _this.formObject.customize = {};
          // sendType 发送类型 0 个人 1 组织 2 岗位
          _this.formObject.customize.userData = [];
          _this.formObject.customize.organData = [];
          _this.formObject.customize.postData = [];
          _.forEach(_this.formObject.scope, function (item) {
            if (item.sendType === 0) {
              _this.formObject.customize.userData.push({
                id: item.userId,
                name: item.userName,
                type: 1
              });
            }
            if (item.sendType === 1) {
              _this.formObject.customize.organData.push({
                id: item.organId,
                name: item.organName,
                typeId: item.typeId
              });
            }
            if (item.sendType === 2) {
              _this.formObject.customize.postData.push({
                id: item.postId,
                name: item.postName,
                type: 2
              });
            }
          });
          _this.formObject.customize.organId = _this.formObject.organId;
          _this.formObject.customize.postId = _this.formObject.postId;
        }
      });
      queryFeedAuditRecord($route.query.id).then(function (res) {
        _this.flowList = res.data.data;
      });
    },
    /**
     * 提交审核
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      var $refs = this.$refs,
        $set = this.$set,
        $confirm = this.$confirm,
        $message = this.$message,
        auditFormObj = this.auditFormObj,
        formObjFeed = this.formObjFeed,
        userInfo = this.userInfo,
        goBack = this.goBack;
      $refs.auditForm.validate(function (valid) {
        if (valid) {
          $confirm("确认提交吗?", "提示", {
            type: "info",
            confirmButtonText: "确认",
            cancelButtonText: "取消"
          }).then(function () {
            $set(auditFormObj, 'sign', userInfo.signImgUrl);
            $set(auditFormObj, 'fbid', formObjFeed.id);
            _this2.loading = true;
            examineFeedback(_objectSpread({}, auditFormObj)).then(function (res) {
              if (res.data.code == 200) {
                $message.success('提交成功');
                goBack();
              }
              _this2.loading = false;
            });
          }).catch(function () {
            _this2.loading = false;
          });
        }
      });
    },
    auditStatusChange: function auditStatusChange(e) {
      var _this3 = this;
      var $route = this.$route;
      if (e.target.value === 1) {
        this.rules.auditOpinion[0].required = true;
      } else if (e.target.value === 3) {
        this.rules.auditOpinion[0].required = true;
        this.rules.node[0].required = true;
        queryFeedAuditRecordRec($route.query.id).then(function (res) {
          _this3.nodeList = res.data.data;
        });
      } else {
        this.rules.auditOpinion[0].required = false;
      }
    },
    /**
     * 驳回节点选择复制
     */
    auditNodeSelect: function auditNodeSelect(value, option) {
      var $set = this.$set,
        auditFormObj = this.auditFormObj;
      $set(auditFormObj, 'allow', option.data.attrs.dataItem.allow);
      $set(auditFormObj, 'appendName', option.data.attrs.dataItem.appendName);
    },
    /**
     * 编辑器
     */
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.editor.disable();
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      var $route = this.$route;
      if ($route.query.type == 3) {
        this.$router.push({
          path: '/docNotice/notice/feedManage'
        });
      } else {
        this.$router.push({
          path: '/docNotice/notice/feedAudit'
        });
      }
    }
  },
  components: {
    Editor: Editor,
    Toolbar: Toolbar,
    selectPerson: selectPerson
  }
};